import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import zh from "./locales/zh.json";
import ms from "./locales/ms.json";

export const LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "zh", label: "中文", short: "中" },
  { code: "ms", label: "Bahasa Melayu", short: "MS" },
];

const STORAGE_KEY = "pos2gto_lang";

const stored = (() => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    return null;
  }
})();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      zh: { translation: zh },
      ms: { translation: ms },
    },
    lng: stored || "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

i18n.on("languageChanged", (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  } catch (e) {
    // ignore storage errors (private mode)
  }
});

document.documentElement.lang = i18n.language || "en";

export default i18n;
